import React, { useMemo } from 'react'

import { NewCountAssetsBadge } from '@components/SelectWithLabeledValue/index.styles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Box } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import { EventsFilterContainer, EventsFilterTitle } from './index.styles'

interface EventsFilterProps {
  onSelect: (id: number) => void
  options: { id: number; label: string; badgeContent?: string | number }[]
  selectedId?: number
}

export const EventsFilter: React.FC<EventsFilterProps> = ({ onSelect, options, selectedId }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const event = useMemo(() => options.find(e => e.id === selectedId), [options, selectedId])

  return (
    <>
      <Box>
        <EventsFilterContainer onClick={handleClick} id="profile-asset-event">
          <EventsFilterTitle>{event?.label}</EventsFilterTitle>
          {!!event?.badgeContent && <NewCountAssetsBadge style={{ margin: '0' }}>{event.badgeContent}</NewCountAssetsBadge>}
          <KeyboardArrowDownIcon sx={anchorEl ? { transform: 'rotate(180deg)' } : {}} />
        </EventsFilterContainer>
      </Box>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map(option => (
          <MenuItem
            onClick={() => {
              onSelect(option.id)
              handleClose()
            }}
            key={option.id}
          >
            {option.label}
            {!!option.badgeContent && <NewCountAssetsBadge>{option.badgeContent}</NewCountAssetsBadge>}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
